<app-main-header class="mt-10"
	><h1 class="pl-5 lg:pl-0 text-lg lg:text-3xl mb-[10px]">
		<span class="text-accentColor">{{ title() }}</span
		><span class="text-mainColor"> {{ titleSuffix() }}</span>
	</h1>
</app-main-header>
@let offerList = offerList$ | async;
@if (!!offerList?.length && !!offerList) {
	<div class="flex flex-col gap-3 md:gap-5">
		@for (offer of offerList$ | async; track offer.product.id; let i = $index) {
			<a
				class="group flex w-auto flex-nowrap justify-between transition rounded-[17px] py-3 px-2 mx-2 hover:bg-mainColor border-accentColor bg-accentColor hover:cursor-pointer shadow-[0px_10px_15px_2px_#00000010]"
				[href]="
					mainService.getOfferUrl(offer) +
					'?' +
					mainService.getUrlParams(offer, 'url', offersFacade.selected$ | async)
				"
				(click)="mainService.handleButtonClick($event, offer)"
			>
				<div
					class="w-1/2 text-sm ml-3 lg:w-3/12 flex items-center font-extrabold transition group-hover:text-white text-white"
				>
					{{ offer.product.name }}
				</div>
				<div class="flex items-center justify-center">
					<div
						class="flex items-center w-full text-sm font-extrabold text-mainColor px-3 group-hover:text-accentColor"
					>
						<span class="pl-2">od {{ offer.fullPrice | price }}/os</span>
					</div>
				</div>
			</a>
		}
	</div>
} @else {
	<app-main-loader></app-main-loader>
}
